export class PatchMethod {
    constructor(
        public value:string,
        public path:string,
        public op:string
    ) { }
  }